import socket from '@/services/socket.js'
import deviceEventTransformer from '@/services/transformers/deviceEventTransformer.js'

export default {
  /**
   * Get children devices in group.
   *
   * @param groupId
   * @returns Promise
   */
  get(groupId) {
    const action = '/device/get/children'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id: groupId
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Get primary device locations.
   *
   * @param group_id
   * @returns Promise
   */
  getLocations(group_id) {
    const action = '/device/location/get/children/primary'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data.locations)
      })
    })
  },

  /**
   * Get aggregated locations.
   *
   * @param device_id
   * @returns Promise
   */
  getAggregatedLocations(device_id) {
    const action = '/device/location/get/aggregated'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        device_id
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  },

  /**
   * Get search events.
   * 
   * @param user_id
   * @param params
   * @returns Promise
   */
  getEvents(user_id, type, params) {
    const action = '/device_event/get_by_user_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id,
        event_names: [type],
        body: { ...params }
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        if (data && data.device_events) {
          let events = data.device_events.map(event => deviceEventTransformer(event))
          resolve(events)
        }

        // If there is no data about device events, consider them as an empty array.
        // If there are no device events in database, the server also sends an empty array.
        resolve([])
      })
    })
  },

  /**
   * Set primary device.
   *
   * @param user_id
   * @param device_id
   * @returns Promise
   */
  setPrimary(user_id, device_id) {
    const action = '/user_device/set_primary'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        body: {
          user_id,
          device_id
        }
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Remove device.
   *
   * @param device_id
   * @returns {Promise<any>}
   */
  remove(device_id) {
    const action = '/device/delete'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        device_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  }
}
